export enum SectionName {
    BILLING_RULES = 'BillingRules',
    REFLEX_RULES = 'ReflexRules',
    CLIENT_IDENTIFIER = 'Client Identifier',
    COPY_TO_ACCOUNT = 'Copy-To Account',
    ORDER_INFROMATION = 'Order Information',
    PATIENT_DONOR_INFORMATION = 'Patient/Donor Information',
    PROFILES = 'Profiles',
    TESTS = 'Tests',
    SINGLE_TEST = 'SingleTest',
    SPECIMEN_INFORMATION = 'Specimen Information'
}

export enum PropertyName {
    BILLING_RULES = 'Billing Rules',
    COPY_TO_ACCOUNT = 'Copy-To Account',
    PROFILES = 'Profiles',
    TESTS = 'Tests',
    REFLEX_RULES = 'Reflex Rules',
    SINGLE_TEST = 'SingleTest',
    AdditionalID_1 = 'AdditionalID#1',
    AdditionalID_2 = 'AdditionalID#2',
    AdditionalID_3 = 'AdditionalID#3',
    AdditionalID_4 = 'AdditionalID#4',
    CentrifugeDate = 'CentrifugeDate',
    ClientDate = 'ClientDate',
    ClientId = 'ClientId',
    CollectionDate = 'CollectionDate',
    DOB = 'DOB',
    DonorType = 'DonorType',
    FilteredDate = 'FilteredDate',
    FirstName = 'FirstName',
    FrozenDate = 'FrozenDate',
    Gender = 'Gender',
    LastName = 'LastName',
    LeftTech = 'LeftTech',
    MiddleInitial = 'MiddleInitial',
    RefrigerationDate = 'RefrigerationDate',
    RightTech = 'RightTech',
    RWBC = 'RWBC',
    SampleCondition = 'SampleCondition',
    SampleSource = 'SampleSource',
    SampleType = 'SampleType',
    SSN = 'SSN',
    STAT = 'STAT',
    TimeZone = 'TimeZone',
    TransfusionType = 'TransfusionType',
    WBC= 'WBC',
    LabportSpecimenCode = 'labportSpecimenCode',
    SpecimenId = 'SpecimenId',
}